"use client"

import React, { ReactElement, ReactNode } from "react"
import MUCheckbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import { Box } from "ui/components/atoms/_atoms"
import { BaseStyles } from "ui/types/base-styles"

import styles from "./TextCheckbox.module.css"

const TextCheckbox = ({
  name,
  error,
  children,
  value,
  rhf,
  onClick,
  ...rest
}: BaseStyles & {
  name: string
  value?: boolean
  error?: {
    type?: string
    message?: string
  }
  children: ReactNode | ReactElement | ReactElement[] | string
  rhf?: object & { ref?: React.Ref<any> }
  onClick?: () => void
}) => {
  return (
    <Box className={styles.wrapper} {...rest}>
      <FormControlLabel
        onClick={onClick}
        control={
          <MUCheckbox
            {...rhf}
            name={name}
            checked={value}
            sx={{
              "color": error ? "var(--color-red)" : "var(--color-second)",
              "&.Mui-checked": {
                color: "var(--color-primary)",
              },
              "& .MuiSvgIcon-root": { fontSize: 20 },
            }}
          />
        }
        label={children}
      />
    </Box>
  )
}

export default TextCheckbox
